import { SaveSheet } from '../../common/types/SaveSheet';

export const getSheetName = (savedSheet: SaveSheet) => {
  if (savedSheet.name) return savedSheet.name;

  if (savedSheet.scanDocumentUrl)
    return savedSheet.scanDocumentUrl.substring(
      savedSheet.scanDocumentUrl.lastIndexOf('/') + 1
    );

  return '(Untitled)';
};
